"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 0 !important;\n\n  & > div > div {\n    padding-left: 16px;\n    padding-top: 34px;\n  }\n\n  & > div > div:focus {\n    padding-left: 16px;\n    background-color: inherit;\n  }\n\n  &:before {\n    border-bottom-color: ", " !important;\n  }\n\n  &:after {\n    border-bottom-color: ", ";\n    transform: ", ";\n  }\n\n  svg {\n    top: calc(50% - 8px);\n    right: 14px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  left: 16px;\n  color: inherit !important;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  display: flex;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  color: ", ";\n\n  & > div > div {\n    width: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var guidGenerator = function guidGenerator() {
  var S4 = function S4() {
    return ((1 + Math.random()) * 0x10000).toString(16).substring(1);
  };

  return "".concat(S4() + S4(), "-").concat(S4());
};

var styles = {
  cssShrink: {
    '&$cssLabel': {
      fontWeight: 600,
      transform: 'translate(0, 13px) scale(0.8)'
    }
  },
  cssLabel: {}
};
var StyledFormControl = (0, _styledComponents.default)(_core.FormControl)(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      disabled = _ref.disabled;
  return !disabled ? theme.palette.common.black : theme.palette.grey[800];
});

var WrapperInput = _styledComponents.default.div(_templateObject2(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.grey['200'];
});

var StyledInputLabel = (0, _styledComponents.default)(_core.InputLabel)(_templateObject3());
var StyledSelectUI = (0, _styledComponents.default)(_Select.default)(_templateObject4(), function (props) {
  return props.theme.palette.grey.A200;
}, function (_ref3) {
  var state = _ref3.state,
      theme = _ref3.theme;
  return state ? theme.palette[state].main : theme.palette.primary.main;
}, function (_ref4) {
  var state = _ref4.state;
  return state && 'scaleX(1)';
});

var Select = function Select(_ref5) {
  var label = _ref5.label,
      classes = _ref5.classes,
      onChange = _ref5.onChange,
      value = _ref5.value,
      options = _ref5.options,
      name = _ref5.name,
      disabled = _ref5.disabled,
      props = _objectWithoutProperties(_ref5, ["label", "classes", "onChange", "value", "options", "name", "disabled"]);

  var id = guidGenerator();
  return _react.default.createElement(StyledFormControl, props, _react.default.createElement(WrapperInput, null, _react.default.createElement(StyledInputLabel, {
    classes: {
      shrink: classes.cssShrink
    },
    FormLabelClasses: {
      root: classes.cssLabel
    }
  }, label), _react.default.createElement(StyledSelectUI, {
    value: value,
    onChange: onChange,
    disabled: disabled,
    inputProps: {
      name: name,
      id: id
    }
  }, options.map(function (o) {
    return _react.default.createElement(_MenuItem.default, {
      key: o.id,
      value: o.id
    }, o.label);
  }))));
};

Select.defaultProps = {
  label: '',
  name: '',
  value: '',
  classes: {},
  disabled: false
};

var _default = (0, _styles.withStyles)(styles)(Select);

exports.default = _default;